import * as React from "react";
export const ModalWithButton = ({ buttonComponent, modalComponent, testId, }) => {
    const [isOpen, setIsOpen] = React.useState(false);
    const toggle = () => {
        setIsOpen((d) => {
            return !d;
        });
    };
    return (React.createElement("div", { "data-testid": testId },
        React.cloneElement(buttonComponent, { onClick: toggle }),
        React.cloneElement(modalComponent, { toggle: toggle, isOpen: isOpen })));
};
//# sourceMappingURL=ModalWithButton.js.map